import { AVAILABLE_CURRENCY } from '../constants';

export const InitialFormValue = {
  currency: AVAILABLE_CURRENCY[0]
};

export * from './login';
export * from './register';
export * from './forgotPassword';
